<template>
	<div class="layout-projects">
		<header-principal class="header-principal"></header-principal>
		<div v-if="accessApp" class="content-main">
            <headerSecundary @returnEventHeader="actionHeader($event)"></headerSecundary>
            <menulateral v-if="showAside" @activarLateral="showAside = $event"></menulateral>
			<div v-if="getHeader" :class="[ 'page-wrapper', {show: showAside}]">
				<router-view></router-view>
			</div>
		</div>
		<footer-principal class="footer-principal"></footer-principal>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import HeaderPrincipal from "@/core/views/Header";
import menulateral from "@/apps/projects/views/projectsAside";
import FooterPrincipal from "@/core/views/Footer";
import headerSecundary from "@/apps/projects/components/headerSecundary";
export default {
    name: "projectsLayout",
    components: {
        HeaderPrincipal,
        menulateral,
        FooterPrincipal,
        headerSecundary
    },
    data() {
        return {
            component: 'menulateral'
        };
    },
    created() {
        if (this.loggedIn && this.getHeader) {
            //console.log('si hay login M');
            this.validAccess();
        }
    },
    methods: {
        validAccess() {
            let t = this;
            t.$store.dispatch("core/apps/validAccess").then((response) => {
                let App = response;
                if (App) {
                    //si tiene projects asignado entonces permitir acceso
                    console.log("Accesso permitido");
                    t.$store.dispatch("ModApps/projects/SetActive", App);
                } else {
                    t.$store.dispatch("ModApps/projects/SetActive", App);
                    console.log("Accesso Negado");
                    t.$router.push({ name: "Home" });
                } //sino volver a home
            });
        },
        actionHeader(action){
            // event emitted from headerSecundary
            console.log('actionHeader', action)
        },
    },
    watch: {
        getHeader: function () {
            //console.log('getHeader ', this.getHeader);
            this.validAccess();
        },
    },
    computed: {
        ...mapGetters("ModApps/projects", {
            accessApp: "accessApp",
            showAside: "lateral",
        }),
        ...mapGetters("core", { getHeader: "getHeader" }),
        ...mapGetters("core/session", { loggedIn: "loggedIn" })
    },
};
</script>
<style scoped lang="scss">
.header {
    top: 0;
}
.page-wrapper {
    margin-left: 0px;
    z-index: initial !important;
}
.page-wrapper.show {
    margin-left: 105px !important;
}
</style>
